// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import moment from 'vue-moment'
import Vue2Filters from 'vue2-filters'
import VueTruncate from 'vue-truncate-filter'
import FBSignInButton from 'vue-facebook-signin-button'
import VueCarousel from 'vue-carousel';
import VueCharts from 'vue-chartjs'
import numeral from 'numeral'
import VueRangedatePicker from 'vue-rangedate-picker'
import VueTimepicker from 'vue2-timepicker'
import Vuebar from 'vuebar';
import VeeValidate from 'vee-validate';
import ToggleButton from 'vue-js-toggle-button'
import VueClipboard from 'vue-clipboard2'
import ModalHelp from '@/components/elements/ModalHelp'
import Tooltip from 'vue-directive-tooltip';
import VueSingleSelect from "vue-single-select";
import VueScrollTo from 'vue-scrollto'
import vSelect from 'vue-select'
import VueFlashMessage from 'vue-flash-message';
import mainMixin from '@/mixins/mainMixin'
import errorMixin from '@/mixins/errorMixin'
import VueSelect from 'vue-cool-select'

import 'vue-directive-tooltip/css/index.css';
import 'vue-flash-message/dist/vue-flash-message.min.css';

import "./filters"
import linkify from 'vue-linkify'
import FlagIcon from 'vue-flag-icon'

import { store } from './store/store'
import PremiumLock from "@/components/elements/PremiumLock"
import PremiumPlanPopup from "@/components/elements/PremiumPlanPopup"
import VueCountdown from '@chenfengyuan/vue-countdown';



Vue.use(VueSelect, {
  theme: 'bootstrap' // or 'material-design'
})

Vue.use(VueFlashMessage);
Vue.use(VueScrollTo)
Vue.use(Tooltip);
Vue.use(VueClipboard)
Vue.use(VeeValidate);
Vue.use(VueCarousel);
Vue.use(FBSignInButton)
Vue.use(VueTruncate)
// Vue.use(Vue2Filters)
Vue.use(moment)
Vue.use(VueRangedatePicker)
Vue.use(VueTimepicker)
Vue.use(Vuebar);
Vue.use(ToggleButton)
Vue.use(FlagIcon)

Vue.component('vue-single-select', VueSingleSelect);
Vue.component('v-select', vSelect)
Vue.component('v-premium-lock', PremiumLock)
Vue.component('v-premium-plan-popup', PremiumPlanPopup)
Vue.component(VueCountdown.name, VueCountdown);

Vue.directive('linkified', linkify)

Vue.config.productionTip = false

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

import { Validator } from 'vee-validate';

Validator.extend('isLessThanOrEqual', (value, [otherValue]) => {
  
  return parseFloat(value) <= parseFloat(otherValue);
}, {
  hasTarget: true,
});

Validator.extend('isUrl',(value) => {
  var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
    '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name and extension
    '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
    '(\\:\\d+)?' + // port
    '(\\/[-a-z\\d%@_.~+&:]*)*' + // path
    '(\\?[;&a-z\\d%@_.,~+&:=-{}()]*)?' + // query string
    '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
  return pattern.test(value);
})

Validator.extend('isPhone', (value) => {
  var pattern = new RegExp(/^[+]?[0-9]{3,12}$/igm);
  return pattern.test(value);
})

Vue.mixin(mainMixin)
Vue.mixin(errorMixin)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
})



// WEBPACK FOOTER //
// ./src/main.js